<template>
    <main id="container-wrap">

        <!-- Header -->
        <section id="content">

        <!-- Main Banner -->
            
            <div id="article">
                <div class="container">
                    <div class="text-box">
                        <p class="title">
                            美国教研团队，专门为母语非英语的孩子研发；
                        </p>
                        <p class="title">
                            包含听、说、读、写的全方位能力提升；
                        </p>
                        <p class="title">
                            原版启蒙学习规划，全面且高效的学习方式；
                        </p>
                        <p class="title">
                            一个会员即可享受自然拼读、分级阅读、场景视频、语法
                        </p>
                    </div>
                </div>
            </div>
            <div id="promo4">
                <template v-if="checkPromotion !== 'membership'">
                    <div class="top">
                        <img v-if="promotionGiftImage"
                            class="gift" :src="promotionGiftImage" alt="gift" />
                        <div>
                            <p class="title">
                                {{ promotionBannerTitle }}
                            </p>
                            <p class="desc">
                                <span>{{ promotionPeriodDesc }}</span>
                            </p>
                        </div>
                    </div>
                    <img v-if="promotionGiftImage"
                        class="gift" :src="promotionGiftImage" alt="gift" />
                    <div
                        v-for="(row, rowIndex) in promotionProductRows"
                        :key="'promo-row-' + rowIndex"
                        class="products"
                    >
                        <MembershipProductCard
                            v-for="product in row"
                            :key="product.title"
                            :product="product"
                            @purchase="openLink"
                        />
                    </div>
                </template>
                <template v-else-if="type === 'membership'">
                    <p class="title">{{ viewConfig.title }}</p>
                    <p class="desc">
                        <span v-for="(text, index) in viewConfig.desc" :key="index">{{ text }}</span>
                    </p>
                    <div class="products">
                        <MembershipProductCard
                            v-for="product in viewProducts"
                            :key="product.title"
                            :product="product"
                            @purchase="openLink"
                        />
                    </div>
                </template>
                <template v-else-if="type === 'new'">
                    <p class="title">{{ viewConfig.title }}</p>
                    <p class="desc">
                        <span v-for="(text, index) in viewConfig.desc" :key="index">{{ text }}</span>
                    </p>
                    <div class="products">
                        <MembershipProductCard
                            v-for="product in viewProducts"
                            :key="product.title"
                            :product="product"
                            @purchase="openLink"
                        />
                    </div>
                </template>
                <template v-else-if="type === 'all'">
                    <div class="products" :class="viewConfig.productsClass">
                        <MembershipProductCard
                            v-for="product in viewProducts"
                            :key="product.title"
                            :product="product"
                            @purchase="openLink"
                        />
                    </div>
                </template>
            </div>

            <div id="promo2">
                <div class="container">
                    <div class="qr-code">
                        <h2>关注官方公众号</h2>
                        <p>了解更多<span>优惠</span>活动</p>
                        <img src="@/assets/membership/img/img-qrcode.png" class="img-qrcode" alt="">
                    </div>

                    <div class="vertical-line"></div>

                    <div class="qr-code">
                        <h2>官方企微客服</h2>
                        <p>1v1人工客服</p>
                        <img src="@/assets/membership/img/img-qqcode2.png" class="img-qqcode" alt="">
                    </div>
                </div>
            </div>

            <div id="promo3">
                <div class="container">
                    <h2 class="title">用户购前须知</h2>
                    <p>支持本页所购商品，下单后7日内无理由退款。超出7日后，不支持退款申请。</p>
                    <p>购买年卡赠送的练习册及其他周边产品一经拆封，不支持退货退款。</p>
                    <p>希注册用户体验会员期间购买并激活年卡，您的使用时间将累计。</p>
                    <p>收到激活码后请在30天内完成激活兑换，如过期未激活者码将失效，请及时联系官方客服咨询解决方案。</p>
                    <p>会员一经激活则正式生效，请确认您激活时登陆使用的账号是否准确，且该账号为您个人使用。如使用非法账号或非个人账号造成的经济损失将由您自行承担。</p>
                    <p>都都GO（原都都英语）要求设备为支持 IOS 15及以上，Android 10及以上的手机或平板电脑、学习机，如使用期间有卡顿、启动闪退等问题，请及时升级您的设备系统。</p>
                    <p>都都会员支持多平台互通，即不论您是安卓设备还是苹果设备，均可登陆同一账号。</p>
                    <p>都都会员仅支持最多不超过5台设备上同时登录。多设备登录极易发生存档丢失、学习进度丢失及其它错误。建议您使用时只在一台设备上进行。</p>
                    <p>为了保证您的财产安全，请不要将您的账号分享给陌生人使用。</p>
                    <p>我们将严厉打击盗版、倒卖非法账号、倒卖激活码的不法行为，同时都都会员不允许一个账号分销给多个用户使用，一经发现将对非法账号和激活码进行封号处理。非正式途径购买账号或激活码造成的经济损失，将由您自行承担。</p>
                    <p>欢迎关注官方微信公众号：都都APP ，如有疑问可咨询官方人工客服（关注微信公众号-转人工客服即可），或官方举报投诉电话：（+86）18810316494.</p>
                </div>
            </div>

        </section>

        <footer>
            <div class="container">
                <p class="rights">ⓒ 2021 Enuma, Inc. All Rights Reserved.</p>
                <div>
                    <p>深圳埃努码信息技术有限公司</p>
                    <p class="v-line"></p>
                    <p style="cursor:pointer" @click="onClickFooterLink(0)">粤ICP备2022075939号</p>
                    <p class="v-line"></p>
                    <div class="ovcn" style="cursor:pointer" @click="onClickFooterLink(1)">
                        <img src="@/assets/common/icn_beiangovcn.png" alt="" />
                        <p>京公网安备 11010502050400号</p>
                    </div>
                </div>
                <p>深圳市南山区南头街道大汪山社区桃园东路1号 西海明珠花园F座2117-1</p>
            </div>
        </footer>

    </main>
</template>
<script>
import MembershipProductCard from './MembershipProductCard'
import {
    PROMOTION_PRODUCT_ROWS,
    VIEW_PRODUCTS,
    getActivePromotion,
    getPromotionGiftImage,
    findActivePromotionId,
    buildProductContext,
    resolveProductRows,
    resolveProducts
} from './membershipProducts'

export default {
    components: { MembershipProductCard },
    computed: {
        type() {
            if (this.$route.query.type === 'new' || this.$route.query.type === 'membership') {
                return this.$route.query.type
            }
            return 'all'
        },
        servertime() {
            return this.$store.state.servertime
        },
        checkPromotion() {
            return findActivePromotionId(this.servertime, this.$moment, {
                isProduction: process.env.NODE_ENV === 'production',
                testQuery: this.$route.query.test || null
            })
        },
        activePromotion() {
            return getActivePromotion(this.checkPromotion)
        },
        isActivePromotion() {
            return this.checkPromotion !== 'membership'
        },
        promotionBannerTitle() {
            return this.activePromotion?.bannerTitle || ''
        },
        promotionGiftImage() {
            return getPromotionGiftImage(this.checkPromotion)
        },
        promotionPeriodDesc() {
            return this.activePromotion?.periodDesc || ''
        },
        productContext() {
            return buildProductContext(this.checkPromotion)
        },
        showBadge() {
            return this.productContext.showBadge
        },
        showOriginalPrice() {
            return this.productContext.showOriginalPrice
        },
        promotionProductRows() {
            return resolveProductRows(PROMOTION_PRODUCT_ROWS, this.productContext)
        },
        viewConfig() {
            return VIEW_PRODUCTS[this.type] || {}
        },
        viewProducts() {
            const products = this.viewConfig.products || []
            return resolveProducts(products, this.productContext)
        }
    },
    mounted() {
        this.checkServerTime()
    },
    methods: {
        checkServerTime() {
            if (!this.servertime) {
                setTimeout(this.checkServerTime, 100)
                return
            }
        },
        openLink(url) {
            if (url) {
                window.open(url, '_blank')
            }
        },
        onClickFooterLink(index) {
            if (index === 0) {
                window.open('https://beian.miit.gov.cn/#/Integrated/index', '_blank')
            } else if (index === 1) {
                window.open('http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010502050400', '_blank')
            }
        }
    }
}
</script>
<style src="@/assets/membership/style.css" />
